import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45227b26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto px-4 py-8" }
const _hoisted_2 = { class: "text-center py-16 sm:py-24" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl sm:text-6xl font-extrabold tracking-tight mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "block text-slate-100" }, "Every Tool You Need,"),
  /*#__PURE__*/_createElementVNode("span", { class: "block bg-gradient-to-r from-primary-400 to-primary-600 bg-clip-text text-transparent" }, " One Click Away. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "max-w-2xl mx-auto text-lg text-slate-400 mb-8" }, " A complete suite of developer utilities designed to boost your productivity. Open source, free, and privacy-focused. ", -1))
const _hoisted_5 = { class: "max-w-md mx-auto relative group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute -inset-0.5 bg-gradient-to-r from-primary-500 to-primary-700 rounded-lg blur opacity-25 group-hover:opacity-75 transition duration-1000 group-hover:duration-200" }, null, -1))
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-slate-500" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "11",
      cy: "11",
      r: "8"
    }),
    /*#__PURE__*/_createElementVNode("line", {
      x1: "21",
      y1: "21",
      x2: "16.65",
      y2: "16.65"
    })
  ])
], -1))
const _hoisted_9 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" }
const _hoisted_10 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_11 = { class: "text-slate-500 text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolCard = _resolveComponent("ToolCard")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            type: "text",
            placeholder: "Search tools (e.g., 'JSON', 'UUID')...",
            class: "block w-full px-4 py-3 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-transparent transition-all"
          }, null, 512), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _hoisted_8
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTools, (tool) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          to: tool.route,
          key: tool.name,
          class: "block h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ToolCard, { tool: tool }, null, 8, ["tool"])
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    (_ctx.filteredTools.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, "No tools found matching \"" + _toDisplayString(_ctx.searchQuery) + "\"", 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = '')),
            class: "mt-4 text-primary-400 hover:text-primary-300 font-medium"
          }, "Clear search")
        ]))
      : _createCommentVNode("", true)
  ]))
}